import { render, staticRenderFns } from "./EditImg.vue?vue&type=template&id=2a6d4a75&scoped=true&"
import script from "./EditImg.vue?vue&type=script&lang=js&"
export * from "./EditImg.vue?vue&type=script&lang=js&"
import style0 from "./EditImg.vue?vue&type=style&index=0&id=2a6d4a75&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6d4a75",
  null
  
)

export default component.exports